"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeClientRect = void 0;
var makeClientRect = function makeClientRect(_ref) {
  var bottom = _ref.bottom,
    left = _ref.left,
    right = _ref.right,
    top = _ref.top;
  var width = right - left;
  var height = bottom - top;
  var props = {
    bottom: bottom,
    height: height,
    left: left,
    right: right,
    top: top,
    width: width,
    x: left,
    y: top
  };
  return _objectSpread({}, props, {
    toJSON: function toJSON() {
      return props;
    }
  });
};
exports.makeClientRect = makeClientRect;